import { useEffect, useState } from 'react';
import { apiSociosNoExterior, type SociosNoExterior as Dados } from '../lib/api';

/**
 * ⭐⭐ **SÓCIO COM DOMICÍLIO NO EXTERIOR — decisão 16 do Richard, 13/09/2026.**
 *
 * *"Em todos os níveis, o fato no quadro societário ('sócio com domicílio
 * declarado em [país]'), sem adjetivo."*
 *
 * ⚠️ **A tela mostra o que o documento imprime, com as mesmas palavras** — a
 * frase vem montada do mesmo jeito (`fraseDoSocioNoExterior`, na API). Só
 * aparece quando alguma empresa do caso tem sócio assim; o aviso de base
 * indisponível já mora no tópico (`IdadeDaBase`).
 */
export function SociosNoExterior({ casoId, chave }: { casoId: string; chave: string }) {
  const [dados, setDados] = useState<Dados | null>(null);

  useEffect(() => {
    let vivo = true;
    apiSociosNoExterior
      .doCaso(casoId)
      .then((r) => vivo && setDados(r.socios))
      .catch(() => vivo && setDados(null));
    return () => {
      vivo = false;
    };
  }, [casoId, chave]);

  if (!dados || dados.empresas.length === 0) return null;

  const mes = /^(\d{4})-(\d{2})/.exec(dados.referencia ?? '');
  const referencia = mes
    ? new Date(Date.UTC(Number(mes[1]), Number(mes[2]) - 1, 1)).toLocaleDateString('pt-BR', {
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC',
      })
    : null;

  return (
    <section className="socios-no-exterior" aria-label="Sócios com domicílio no exterior">
      <p className="socios-no-exterior-titulo">Sócios com domicílio no exterior</p>
      <p className="ajuda">
        Quadro societário perante a Receita Federal{referencia ? `, referência ${referencia}` : ''}.
        Sai assim no relatório, logo abaixo do organograma — o fato, sem adjetivo.
      </p>
      {dados.empresas.map((e) => (
        <div key={e.cnpj} className="socios-no-exterior-empresa">
          <p className="socios-no-exterior-razao">
            <strong>{e.razaoSocial}</strong> <span className="dado">CNPJ {e.cnpj}</span>
          </p>
          <ul>
            {e.socios.map((s, i) => (
              <li key={`${s.nome}-${i}`}>
                {s.nome} — sócio com domicílio declarado em {s.pais}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
}
